/**
 * @generated SignedSource<<45f1b10fe0d5000c1a92efc8a86cf131>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type marketplacePreviewUrlDialogQuery$variables = {
  productID: string;
};
export type marketplacePreviewUrlDialogQuery$data = {
  readonly marketplaceProductPreviewUrl: string | null;
};
export type marketplacePreviewUrlDialogQuery = {
  response: marketplacePreviewUrlDialogQuery$data;
  variables: marketplacePreviewUrlDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productID",
        "variableName": "productID"
      }
    ],
    "kind": "ScalarField",
    "name": "marketplaceProductPreviewUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "marketplacePreviewUrlDialogQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "marketplacePreviewUrlDialogQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1cbc33e7efdac66099cad56037dcb1e6",
    "id": null,
    "metadata": {},
    "name": "marketplacePreviewUrlDialogQuery",
    "operationKind": "query",
    "text": "query marketplacePreviewUrlDialogQuery(\n  $productID: ID!\n) {\n  marketplaceProductPreviewUrl(productID: $productID)\n}\n"
  }
};
})();

(node as any).hash = "0775fa111b5a95274e8fc50042b5bcc8";

export default node;
